import { NgModule, NgModuleFactory, ModuleWithProviders } from '@angular/core';
import { CoreModule, LazyModuleFactory } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { GoliathDocumentsRoutingModule } from './goliath-documents-routing.module';
import { DwAgGridModule } from '@digiwall/ag-grid';
import { DocumentsModule } from './documents/documents.module';
import { LocalizationResourceName } from '@digiwall/core-features';
import { ShapingDialogComponent } from './components/shapings/shaping-dialog.component';
import { SharedModule } from '@digiwall/goliath-core';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { GoliathShapingManagementModule } from '@digiwall/goliath-shaping-management';
import { CalculatorRendererComponent } from './components/shapings/renderer/renderer.component';
import { DwReadonlyFormDirective } from '@digiwall/core';

@NgModule({
  imports: [
    CoreModule,
    ThemeSharedModule,
    GoliathDocumentsRoutingModule,
    DwAgGridModule,
    DocumentsModule,
    SharedModule,
    DialogBoxComponent,
    GoliathShapingManagementModule,
    DwReadonlyFormDirective,
    ShapingDialogComponent,
    CalculatorRendererComponent,
  ],
  providers: [
    {
      provide: LocalizationResourceName,
      useValue: 'Doc',
    },
  ],
})
export class GoliathDocumentsModule {
  static forChild(): ModuleWithProviders<GoliathDocumentsModule> {
    return {
      ngModule: GoliathDocumentsModule,
      providers: [],
    };
  }

  static forLazy(): NgModuleFactory<GoliathDocumentsModule> {
    return new LazyModuleFactory(GoliathDocumentsModule.forChild());
  }
}
